import '../style.css';

const { VITE_MMFA_URL } = typeof import.meta !== 'undefined' ? import.meta.env : process.env;
const SuccessResponse = ()=>{
    
    const handleRegisterKey = ()=> {
        window.location.href = VITE_MMFA_URL;
    }
    return (
        <div className='container'>
            <div className='response-overlay'>
            <div className='response-box'>
            <div className='success-response'>
    <p>Verification Successful</p>
    <div className='description'>Thank you for completing CLEAR ID Verification. <br/><br/>
        Select <strong>Register</strong> below to begin the multifactor setup process for your T-Mobile account. 
        <br/><br/>You will follow the on-screen prompts and use the CLEAR ID you just completed to register 
        your YubiKey security key and Microsoft Authenticator methods.</div>
        <div className='status-success' onClick={handleRegisterKey} data-testid="register-btn">
            Register
        </div>
    </div>
            </div>
            </div>
    </div>

    )
    
};

export default SuccessResponse;